import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_SALARY = 0;
const DEFAULT_MAX_SALARY = 100000;

export const salaryDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.SALARY,
  name: 'Salary',
  type: FilterType.RANGE,
  min: DEFAULT_MIN_SALARY,
  max: DEFAULT_MAX_SALARY,
  isActive: false,
  isVisible: true,
};

export const salaryHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    // Only apply defaults if BOTH min and max are undefined
    // If only one is undefined, keep it undefined (for "greater than" / "less than" filters)
    const shouldApplyDefaults =
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined;

    if (shouldApplyDefaults) {
      return {
        ...currentFilterState,
        min: DEFAULT_MIN_SALARY,
        max: DEFAULT_MAX_SALARY,
      };
    }

    // Preserve the user's selection - don't fill in undefined values
    return currentFilterState;
  },
};
